import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export const Navigations = () => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const getClassNames = (path) => {
        return location.pathname === path 
            ? "active-nav c-basic ft-w-bold txt-no-decorate" 
            : "c-light txt-no-decorate";
    };

    const navItems = [
        { to: "/", label: "Home" },
        { to: "/portfolio", label: "Portfolio" },
        { to: "/resume", label: "Resume" },
        { to: "/about", label: "About" },
        { to: "/contact", label: "Contact" }
    ];

    return (
        <div className="navigation-container">
            {/* Hamburger button */}
            <div 
                className={`hamburger ${isOpen ? "active" : ""}`} 
                onClick={() => setIsOpen(!isOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Navigation links */}
            <div className={`nav-links ${isOpen ? "open" : ""}`}>
                {navItems.map((item) => (
                    <NavLink 
                        key={item.to} 
                        to={item.to} 
                        className={getClassNames(item.to)}
                        onClick={() => setIsOpen(false)} // close menu on link click
                    >
                        {item.label}
                    </NavLink>
                ))}
            </div>
        </div>
    );
};
